import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import { Message } from 'element-ui';

export const fetchEventProfileInfo = ({commit, dispatch}) => {

    axios.get('/customerPortal/eventSingle.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('unsetOverlayState')
        if(res.data.status) {
            const response = res.data.response[0]            
            commit('setEventProfileInfo', response)    
            dispatch('fetchFoodMenuProfileInfo', response.menu.id)
        }        
    })
    .catch(error => {
        console.log(error)
    })

}

export const submitClientFoodMenuSelection = ({commit, dispatch}, payload) => {

    console.log(JSON.stringify(payload))
    commit('toggleEventButtonLoading', true)
    axios.post('/enquiries/submitClientFoodMenuSelection.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        console.log(JSON.stringify(res.data))
        commit('toggleEventButtonLoading', false)
        if(res.data.pdf_path && payload.client_selection_food_menu_allowed === 1) {
            window.open(res.data.pdf_path)
        } else if(res.data.status) {
            alert('Borrador enviado')
            if(payload.client_selection_food_menu_allowed === 1) {
                //window.location.reload()
            }            
        }
    })
    .catch(error => {
        console.log(error)
    })

}

export const downloadClientFoodMenuSelection = ({commit, dispatch}, payload) => {

    commit('toggleEventButtonLoading', true)
    axios.post('/enquiries/downloadClientSelections.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('toggleEventButtonLoading', false)
        if(res.data.pdf_path) {
            window.open(res.data.pdf_path)
        }
    })
    .catch(error => {
        console.log(error)
    })

}

export const fetchTableList = ({commit}) => {

    axios.get('/customerPortal/guest/fetchTableList.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setTableList', res.data.response)
        commit('setTableLoading', false)
    })
    .catch(error => {
        console.log(error)
    })

}

export const fetchGuestList = ({commit, dispatch}, payload) => {
    
    commit('toggleEventButtonLoading', payload.fetchAll)
    axios.post('/customerPortal/guest/fetchGuestList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        if(payload.fetchAll) {
            commit('setGuestList', {addType: 'fresh', dataList: res.data.response})  
            /*
            if(!payload.startIndex) {
                payload.startIndex = 0
            }
            if(payload.startIndex === 0) {
                commit('setGuestList', {addType: 'fresh', dataList: res.data.response})    
            } else {
                commit('setGuestList', {addType: 'push', dataList: res.data.response})    
            }
            const startIndex = parseInt(payload.startIndex)
            if(startIndex<parseInt(res.data.totalRecords)) {
                payload.startIndex = startIndex+10
                dispatch('fetchGuestList', payload)
            } else {
                commit('toggleEventButtonLoading', false)    
            }*/
        } else {
            console.log(JSON.stringify(res.data.response))
            commit('replaceGuestSingle', res.data.response)            
        }
        commit('resetGuestListIndex')        
    })
    .catch(error => {
        console.log(error)
    }).finally(() => {
        commit('toggleEventButtonLoading', false)  
    })

}

export const fetchGuestSingle = ({commit}, payload) => {

    axios.post('/customerPortal/guest/fetchGuestSingle.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 

        if(res.data.status) {
            commit('setGuestSingle', res.data.response)
            commit('toggleGuestEditBox', true)
        } else {
            alert('Failed!!!')
        }
        
    })
    .catch(error => {
        console.log(error)
    })

}

export const fetchGuestRecipeList = ({commit}, payload) => {

    axios.post('/customerPortal/guest/fetchGuestRecipeList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        Message.closeAll()

        commit('setGuestRecipeList', res.data.response)
        
    })
    .catch(error => {
        console.log(error)
    })

}

export const saveGuestRecipeList = ({commit, dispatch}, payload) => {

    axios.post('/customerPortal/guest/saveGuestRecipeList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
    
        dispatch('fetchGuestRecipeList', {recipe_id: payload.recipe_id})
        
    })
    .catch(error => {
        console.log(error)
    })

}

export const saveGuest = ({commit, dispatch}, payload) => {

    axios.post('/customerPortal/guest/saveGuest.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        if(res.data.status) {
            dispatch('fetchGuestList', {fetchlatest: payload.id === 0, fetchAll: false, startIndex: 0, guest_id: payload.id})
            //dispatch('fetchTableList')
            commit('toggleGuestEditBox', false)
        }
    })
    .catch(error => {
        console.log(error)
    })

}

export const saveGuestTable = ({commit, dispatch}, payload) => {

    axios.post('/customerPortal/guest/saveGuestTable.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        if(res.data.status) {
            commit('resetGuestDataLoadingStatus', payload)
            dispatch('fetchTableList')
        }
    })
    .catch(error => {
        console.log(error)
    })

}

export const deleteGuest = ({commit, dispatch}, payload) => {

    axios.post('/customerPortal/guest/deleteGuest.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('removeGuestListItem', {id: payload.guest_id})
        //dispatch('fetchGuestList', {fetchlatest: false, fetchAll: true, startIndex: 0, guest_id: 0})
        dispatch('fetchTableList')
        //commit('toggleGuestEditBox', false)
    })
    .catch(error => {
        console.log(error)
    })

}

export const createTable = ({commit, dispatch}, payload) => {

    axios.post('/customerPortal/guest/createTable.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 

        if(res.data.status) {
            dispatch('fetchTableList')
            //dispatch('fetchGuestList', {fetchlatest: false, fetchAll: true, startIndex: 0, guest_id: 0})
            commit('toggleGuestEditBox', false)
        }

    })
    .catch(error => {
        console.log(error)
    })

}

export const deleteTable = ({commit, dispatch}, payload) => {

    commit('setTableLoading', true)
    axios.post('/customerPortal/guest/deleteTable.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('toggleGuestTableNumberId', {table_number_id: payload.table_id})
        dispatch('fetchTableList')
        commit('toggleGuestEditBox', false)
    })
    .catch(error => {
        console.log(error)
    })

}

export const sendGuestInvitation = ({dispatch}, payload) => {

    setTimeout(() => {
        dispatch('fetchGuestList', {fetchlatest: false, fetchAll: true, startIndex: 0, guest_id: 0})
        dispatch('fetchTableList')
    }, 2000);
    axios.post('/customerPortal/guest/sendGuestInvitation.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        console.log(JSON.stringify(res.data))
    })
    .catch(error => {
        console.log(error)
    })

}

export const fetchTableClothList = ({commit}) => {

    axios.get('/customerPortal/fetchTableClothList.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('setTableClothList', res.data.response)    
        }
        
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const fetchCakeList = ({commit}) => {

    axios.get('/customerPortal/fetchCakeList.php', accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('setCakeList', res.data.response)    
        }

    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const setEventTableClothId = ({commit}, payload, ) => {

    axios.post('/customerPortal/setEventTableClothId.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        alert('Se establece la preferencia del mantel.')
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const setEventCakeId = ({commit}, payload, ) => {

    axios.post('/customerPortal/setEventCakeId.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        alert('Se selecciona la torta alusiva.')
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const fetchEventType = ({commit}) => {

    axios.get('/customerPortal/fetchEventType.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setEventType', res.data.response)
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const updateEventDaySchedule = ({commit}, payload) => {

    axios.post('/customerPortal/updateEventDaySchedule.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setDayScheduleEdit', false)
        alert('Gracias!!')
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const updateEventObservation = ({commit}, payload) => {

    axios.post('/customerPortal/updateEventObservation.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setObservationEdit', false)
        alert('Gracias!!')
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const uploadEventMediaFile = ({commit}, payload) => {

    axios.post('/serviceProviderPortal/uploadEventMediaFile.php', payload)
    .then(res => {
        console.log(JSON.stringify(res.data))
    })
    .catch(error => {
        console.log(error)
                        
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/events/actions.js